module.exports = __webpack_public_path__ + "static/media/vnda1.462ebbfa.png";